import { useTranslation } from "react-i18next";
import Loader from "../../Loader";
import { cn } from "../../../lib/utils";

/**
 * A poster being built for the paper this conversation is about.
 *
 * Stacked above the composer rather than in place of it: this is a status, not
 * a proposal, and the reader must keep the composer while it runs — the whole
 * point of generating in the background is that they carry on reading and
 * asking. The completion is announced app-wide by `useVisualAbstractWatcher`,
 * so this strip only has to say that something is under way, wherever the
 * reader happens to be on this screen.
 *
 * Presentational on purpose: it does not poll, and does not know what it is
 * waiting for.
 */
export function VisualAbstractGeneratingNotice(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        // `mb-2` because the stack above the composer has no gap of its
        // own: PushSuggestionCard and the attachment chips carry theirs too.
        "mb-2 flex w-full items-center gap-2 rounded-2xl px-4 py-3",
        "border border-solid border-ds-slate-100",
        "bg-[rgba(253,253,253,0.9)] backdrop-blur-[3px]",
        "shadow-[0px_14px_18px_rgba(13,20,18,0.16)]",
        "font-dm-sans text-footnote text-ds-slate-600"
      )}
    >
      <Loader />
      <span>{t("Generating the visual abstract…")}</span>
    </div>
  );
}
